import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../../httpClient/serverApi/types/IGetItemsResult';
import { IGroup } from '../types/IGroup';

export interface IGetGroupsParams extends IGetItemsParams {
}

export interface IGetGroupsResult extends IGetItemsResult {
  groups: IGroup[];
}

export class GetGroupsRequest extends Request<IGetGroupsParams, IGetGroupsResult> {
  constructor(params: IGetGroupsParams) {
    super('getGroups', params);
  }
}
